"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.FlightStyled = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _palette = require("../../../styles/palette");

var _widths = require("../../../styles/widths");

var _templateObject, _templateObject2, _templateObject3;

var Container = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  align-items   : center;\n  display       : flex;\n  min-height    : 39px;\n  padding-bottom: 20px;\n  text-align    : left;\n"])));

exports.Container = Container;
Container.displayName = 'Container';

var FlightStyled = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  align-items   : center;\n  color         : ", ";\n  display       : flex;\n  flex-direction: column;\n  font-size     : 12px;\n  font-weight   : ", ";\n  width         : 100%;\n"])), _palette.palette.lightGrey, _widths.font.semi);

exports.FlightStyled = FlightStyled;
FlightStyled.displayName = 'FlightStyled';

var Title = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  color      : ", ";\n  font-size  : 24px;\n  font-weight: ", ";\n"])), _palette.palette.bobBlack, _widths.font.semi);

exports.Title = Title;
Title.displayName = 'Title';